import styled from 'styled-components'

export const ListWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  max-width: 661px;
  row-gap: 0.4em;
  @media (max-width: 991px) {
    display: flex;
    flex-direction: column;
    gap: 0.4em;
  }
`

export const ItemWrapper = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
`
